import { api } from "./apiClient";

export const adminService = {
  stats: async () => (await api.get("/admin/stats")).data,
  securityEvents: async () => (await api.get("/admin/security/events")).data,
  blockIp: async (ip, note = "") => (await api.post("/admin/security/blocked-ips", { ip, note })).data,
  unblockIp: async (ip) => (await api.delete("/admin/security/blocked-ips", { params: { ip } })).data,
  clearSecurityEvents: async (days = 0) =>
    (await api.delete("/admin/security/events", { params: { days } })).data,
  listUsers: async (params = {}) => (await api.get("/admin/users", { params })).data,
  supAudit: async (params = {}) => (await api.get("/admin/sup-audit", { params })).data,
  supHidden: async () => (await api.get("/admin/sup-hidden")).data,
  supervisors: async () => (await api.get("/admin/supervisors")).data,
  setSupervisorStatus: async (id, status) => (await api.post(`/admin/supervisors/${id}/status`, { status })).data,
  setSupervisorPassword: async (id, password) => (await api.post(`/admin/supervisors/${id}/password`, { password })).data,
  setSupervisorTrading: async (id, enabled) => (await api.post(`/admin/supervisors/${id}/trading`, { enabled })).data,
  setSupervisorSupport: async (id, enabled) => (await api.post(`/admin/supervisors/${id}/support`, { enabled })).data,
  purgeAudit: async (payload) => (await api.post("/admin/sup-audit/purge", payload)).data,
  exportClients: async (brandId) => (await api.get("/admin/export/clients", {
    params: brandId ? { brand_id: brandId } : {},
    responseType: "blob",
  })),
  restoreHidden: async (id) => (await api.post(`/admin/sup-hidden/${id}/restore`)).data,
  purgeHidden: async (id) => (await api.delete(`/admin/sup-hidden/${id}`)).data,
  bulkHidden: async (ids, action) =>
    (await api.post("/admin/sup-hidden/bulk", { ids, action })).data,
  tradingClients: async (search = "") => (await api.get("/admin/trading/clients", { params: { search } })).data,
  tradingClient: async (id) => (await api.get(`/admin/trading/clients/${id}`)).data,
  adjustPosition: async (id, payload) => (await api.patch(`/admin/trading/positions/${id}`, payload)).data,
  createUser: async (payload) => (await api.post("/admin/users", payload)).data,
  updateUser: async (id, payload) => (await api.patch(`/admin/users/${id}`, payload)).data,
  adjustBalance: async (id, amount, note, target = "balance") =>
    (await api.post(`/admin/users/${id}/balance`, { amount, note, target })).data,
  deleteUser: async (id) => (await api.delete(`/admin/users/${id}`)).data,
  listCodes: async () => (await api.get("/admin/invite-codes")).data,
  createCode: async (payload) => (await api.post("/admin/invite-codes", payload)).data,
  updateCode: async (id, payload) => (await api.patch(`/admin/invite-codes/${id}`, payload)).data,
  deleteCode: async (id) => (await api.delete(`/admin/invite-codes/${id}`)).data,
};
